import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';

import { ExamBoardsComponent } from './exam-boards.component';
import { AddEditExamBoardComponent } from './components/add-edit-exam-board/add-edit-exam-board.component';
import { ExamBoardService } from '../../../../services/exam-board/exam-board.service';
import { ShiftService } from '../../../../services/shifts/shift.service';
import { SubjectService } from '../../../../services/subject/subject.service';

const routes = [
    {
        path: 'pages/management/exam-boards/:examCallId/:schoolYearId',
        component: ExamBoardsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_EXAM_CALLS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        ExamBoardsComponent,
        AddEditExamBoardComponent,
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule
    ],
    exports: [
        ExamBoardsComponent
    ],
    entryComponents: [
        AddEditExamBoardComponent,
    ],
    providers: [
        ExamBoardService,
        ShiftService,
        SubjectService
    ]
})
export class ExamBoardsModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-boards/exam-boards.module.ts